import Icons from 'assets/icons';

export interface MonitoringWarningAlertProps {
  message: string;
}

const MonitoringWarningAlert = ({ message }: MonitoringWarningAlertProps) => (
  <span className="mt-1 inline-flex items-center gap-1 rounded-md border border-amber-300 px-1.5 py-1.5 text-xs font-medium text-amber-700">
    <Icons.Warning className="size-3.5 shrink-0" aria-hidden="true" />
    <span>{message}</span>
  </span>
);

export default MonitoringWarningAlert;
